<template>
  <div class="toast-container">
    <TransitionGroup name="toast-animation">
      <ToastNotification
        v-for="toast in toasts"
        :key="toast.id"
        :message="toast.message"
        :type="toast.type"
        @remove="removeToast(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>

<script setup>
import { useToast } from '../composables/useToast';
import ToastNotification from './ToastNotification.vue';

const { toasts, removeToast } = useToast();
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* Animasi untuk notifikasi yang muncul dan hilang */
.toast-animation-enter-active,
.toast-animation-leave-active {
  transition: all 0.5s ease;
}
.toast-animation-enter-from,
.toast-animation-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>